import React, { useState } from 'react';
import { Tooltip } from 'reactstrap';
import PropTypes from 'prop-types';
import './customTooltip.css';

function CustomToolTip(props) {
    const { placement, target, text, hide } = props;
    const [tooltipOpen, setTooltipOpen] = useState(false);

    const toggle = () => setTooltipOpen(!tooltipOpen);

    return (
        <Tooltip
            placement={placement}
            isOpen={tooltipOpen}
            target={target}
            toggle={toggle}
            autohide={false}
        >
            {text}
        </Tooltip>
    );
}

CustomToolTip.propTypes = {
    placement: PropTypes.string,
    text: PropTypes.string,
    target: PropTypes.string,
    hide: PropTypes.bool,
};

CustomToolTip.defaultProps = {
    placement: "top",
    hide: true,
};


export default CustomToolTip;
